var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2920_38562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0017 0.904694L14.733 3.17344L20.8267 9.26719L23.0955 6.99844C24.2674 5.82657 24.2674 3.92813 23.0955 2.75626L21.2486 0.904694C20.0767 -0.267181 18.1783 -0.267181 17.0064 0.904694H17.0017ZM13.6736 4.23282L2.74704 15.1641C2.25954 15.6516 1.90329 16.2563 1.70641 16.9172L0.0470384 22.5563C-0.0701491 22.9547 0.0376634 23.3813 0.328288 23.6719C0.618913 23.9625 1.04548 24.0703 1.43923 23.9578L7.07829 22.2984C7.73923 22.1016 8.34391 21.7453 8.83141 21.2578L19.7674 10.3266L13.6736 4.23282Z",
    fill: "#ECEEEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2920_38562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.192180716e6800de4e0cb02387376934.svg";
export { ForwardRef as ReactComponent };